import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { NgModule } from '@angular/core';
import { Router } from '@angular/router';
import { AuthModule } from 'angular-auth-oidc-client';
import {
  WF_IDLE_STRATEGY,
  WfAuthInterceptor,
  WfAuthModule,
} from 'wflow-features/auth';
import { WfDialogService } from 'wflow-ui';
import { environment } from '../../environments';
import { APP_ROUTES } from '../routing.const';
import { IdleStrategy } from './idle.strategy';

const host = location.origin + '/';

@NgModule({
  imports: [
    WfAuthModule.forRoot({
      authority: environment.accountApi,
      clientId: 'wflow_main_app_6_5',
      redirectUri: host,
      scope:
        'openid profile uccl_api uccl_common_api wflow_main_api offline_access',
      idleEnabled: true,

      unauthorizedRedirectUri: `${host}/${APP_ROUTES.UNAUTHORIZED}`,
      forbiddenRedirectUri: `${host}/${APP_ROUTES.FORBIDDEN}`,
      logoutRedirectUri: `${host}/${APP_ROUTES.LOGOUT}`,

      syncCallback: (response, injector) => {
        if (!response?.isAuthenticated) {
          const router = injector.get(Router);
          if (
            router.url.startsWith(`/${APP_ROUTES.REGISTRATION}`) ||
            location.pathname.startsWith(`/${APP_ROUTES.REGISTRATION}`)
          ) {
            return;
          }

          const dialogSvc = injector.get(WfDialogService);

          dialogSvc.closeAll();

          router.navigate([`/${APP_ROUTES.UNAUTHORIZED}`], {
            queryParams: {
              autoAuthorize: false,
              redirectUrl: router.url,
            },
          });
        }
      },
    }),
  ],
  providers: [
    {
      provide: HTTP_INTERCEPTORS,
      useClass: WfAuthInterceptor,
      multi: true,
    },

    IdleStrategy,
    {
      provide: WF_IDLE_STRATEGY,
      useExisting: IdleStrategy,
    },
  ],
  exports: [AuthModule],
})
export class AuthConfigModule {}
